import axios from 'axios';
import ProductGroups from '@/components/containers/bulk-product/utils/product-groups';

const preSeason = {
  namespaced: true,
  state: {
    shipments: {},
    currentShipment: {},
    validators: [],
    shipmentsGrid: {},
    orderFormType: null,
    orderFormTitle: null,
    updatedShipments: {},
    orderReview: {},
    dataIsLoading: false,
    updateShipmentDetails: null,
    successOnOverview: false,
  },
  getters: {
    shipments: (state) => state.shipments,
    validators: (state) => state.validators,
    orderFormType: (state) => state.orderFormType,
    shipmentsGrid: (state) => state.shipmentsGrid,
    orderFormTitle: (state) => state.orderFormTitle,
    updatedShipments: (state) => state.updatedShipments,
    orderReview: (state) => state.orderReview,
    dataIsLoading: (state) => state.dataIsLoading,
    updateShipmentDetails: (state) => state.updateShipmentDetails,
    successOnOverview: (state) => state.successOnOverview,
  },
  mutations: {
    fetchShipments(state, payload) {
      state.shipments = payload;
    },
    fetchShipmentsGrid(state, payload) {
      state.shipmentsGrid = payload;
    },
    saveShipment(state, payload) {
      state.shipments = payload;
    },
    deleteShipment(state, shipmentNumber) {
      state.shipments.splice(shipmentNumber, 1);
    },
    addShipment(state, newShipment) {
      state.shipments.push(newShipment);
    },
    updateValidators(state, validator) {
      state.validators.push(validator);
    },
    setOrderFormType(state, orderFormType) {
      state.orderFormType = orderFormType;
    },
    setOrderFormTitle(state, orderFormTitle) {
      state.orderFormTitle = orderFormTitle;
    },
    updateShipment(state, variant) {
      state.updatedShipments[variant.updatedShipment.gridIndex][variant.variantIndex].updatedShipments =
        variant.updatedShipment.updatedShipments;
    },
    addUpdateShipment(state, updatedShipment) {
      state.updatedShipments[updatedShipment.gridIndex].push(updatedShipment);
    },
    fetchReview(state, payload) {
      state.orderReview = payload;
    },
    setLoadingState(state, dataIsLoading) {
      state.dataIsLoading = dataIsLoading;
    },
    updateShipmentDetails(state, updateShipmentDetails) {
      state.updateShipmentDetails = updateShipmentDetails;
    },
    showSuccessOnOverview(state, successOnOverview) {
      state.successOnOverview = successOnOverview;
    },
  },
  actions: {
    async fetchShipments({commit}, orderFormType) {
      const shipmentData = await axios.get(`pre-season-orders-api/shipments/${orderFormType}/`);
      let shipmentList = shipmentData.data.data.orderShipments;
      let isShipmentFormEditable = shipmentData.data.data.isShipmentFormEditable || false;
      commit('fetchShipments', shipmentList);
      commit('updateShipmentDetails', isShipmentFormEditable);
    },
    async fetchShipmentsGrid({commit}, formId) {
      const data = await axios.get(`pre-season-orders-api/${formId}`);
      const records = data?.data?.data?.results;
      const productGroups = [];

      if (records.length > 0) {
        commit('setOrderFormTitle', records[0].bulkOrderFormTitle);
        records.forEach((record) => {
          productGroups.push(...new ProductGroups(record).getProductGroups());
        });
      }
      return await commit('fetchShipmentsGrid', productGroups);
    },
    async saveShipment({commit, state}) {
      let shipmentData = {
        preseasonOrderType: state.orderFormType,
        orderShipments: state.shipments, // This includes all order data
      };
      return await axios
        .put(`pre-season-orders-api/save-shipments`, shipmentData)
        .then((submitResponse) => {
          commit('saveShipment', submitResponse.data.data.orderShipments);
          return submitResponse;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async saveQuantity({state}, gridIndex) {
      return await axios
        .put(`pre-season-orders-api/saveShipmentEntries`, state.updatedShipments[gridIndex])
        .then((response) => {
          return response;
        });
    },
    deleteShipment({commit}, shipmentNumber) {
      commit('deleteShipment', shipmentNumber);
    },
    addShipment({commit}, newShipment) {
      commit('addShipment', newShipment);
    },
    async updateValidators({commit}, validator) {
      await commit('updateValidators', validator);
    },
    setOrderFormType({commit}, orderFormType) {
      commit('setOrderFormType', orderFormType);
    },
    updateShipment({commit, state}, variantData) {
      let updatedShipment = {
        sku: variantData.code,
        orderFormID: variantData.formId,
        warehouse: variantData.availableWarehouse,
        updatedShipments: variantData.shipments,
        gridIndex: variantData.gridIndex,
      };
      //grid exist in update map
      if (state.updatedShipments[variantData.gridIndex]) {
        // variant exist in grid map
        let variantIndex = state.updatedShipments[variantData.gridIndex].findIndex(
          (variant) => variant && variant.sku == variantData.code
        );
        if (variantIndex >= 0) {
          commit('updateShipment', {variantIndex, updatedShipment});
        } else {
          commit('addUpdateShipment', updatedShipment);
        }
      } else {
        state.updatedShipments[variantData.gridIndex] = [];
        commit('addUpdateShipment', updatedShipment);
      }
    },
    async reviewOrder({commit}, orderFormType) {
      commit('setLoadingState', true); //turns on loading indicator until data returns

      try {
        const response = await axios.get(`pre-season-orders-api/review/${orderFormType}`);

        if (response.status === 200) {
          let reviewData = response.data;
          commit('fetchReview', reviewData);
          commit('setLoadingState', false);
        }
      } catch (error) {
        console.error('/review error:', error);
        return error;
      }
    },
  },
};

export default preSeason;
